import { OptionType } from '@evinced-private/ui-common';

import { ProductType } from 'src/common/interfaces/Tenant';

export type MobilePlatform = 'ios' | 'android' | 'all';

export const MOBILE_PLATFORM_FILTER_ID = 'platform';
export const MOBILE_APP_ID_FILTER_ID = 'appId';

export const MOBILE_PLATFORM_OPTIONS: OptionType[] = [
	{ value: 'all', label: 'All platforms' },
	{ value: 'ios', label: 'iOS' },
	{ value: 'android', label: 'Android' }
];

export const DEFAULT_MOBILE_PLATFORM: MobilePlatform = 'all';

export const parseMobilePlatform = (value: unknown): MobilePlatform => {
	if (value === 'ios' || value === 'android' || value === 'all') {
		return value;
	}
	return DEFAULT_MOBILE_PLATFORM;
};

export const MOBILE_DASHBOARD_PRODUCT_NAMES = [
	ProductType.MOBILE_FLOW_ANALYZER,
	ProductType.MOBILE_SDK
] as const;

export const IOS_OS_VALUES = ['ios', 'iOS'];
export const ANDROID_OS_VALUES = ['android', 'Android'];
